import React, { useRef, memo } from 'react';

// const TeeCard = (props)=> {
const TeeCard = memo((props) => {
    
    // const { book, onBookSelect, isBookingAllowed } = props;
    const { book, onBookSelect, isBookingAllowed, isBookingInProgress } = props;

    // useRef is synchronous — survives re-renders without stale-closure risk
    const isClickingRef = useRef(false);

    const handleClick = async () => {
        if (isClickingRef.current || isBookingInProgress) return;
        isClickingRef.current = true;
                
        try {
            await onBookSelect(book);
        } finally {
            isClickingRef.current = false;
        }
    };

    return(<>
        <div  className="col-md-6 col-sm-6 col-lg-3 padding-0" >
            {/* <div className={`slot-card ${ (!!book.Status || (isBookingAllowed) ) && 'disableClick'}`} onClick={() => onBookSelect(book)} > */}
            <div className={`slot-card ${ (!!book.Status || !!isBookingAllowed || isBookingInProgress ) && 'disableClick'}`} 
                onClick={handleClick}
            >
                <div className={`${ (!book.Status) ? 'slot-card-header':(book.Status == 'Pending')? 'slot-card-header-pending' :'slot-card-header-blur' }`}> 
                    <div className="row margin-0">
                        <div className="col-xs-12 padding-0">
                            <b> {book.Slot} </b>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
});
// }


export default TeeCard;